import React from 'react'
import FooterBottomStyleWrapper from "./FooterBottom.style";
import LogoImage from "../../assets/images/logo.png";
import Social from './SocialProfile'

export default function Footer() {
    return (
        <FooterBottomStyleWrapper className="footer_bottom_wrapper nasalization">
            <div className="container">
                <div className="footer-bottom-content">
                    <a href="# " className="footer-logo">
                        <img src={LogoImage} alt="footer logo" />
                    </a>
                    <Social />
                    <ul className="footer-menu">
                        <li>
                            <a href="# ">Home</a>
                        </li>
                        <li>
                            <a href="https://app.orbpad.finance/presale" target="_blank">Launchpad</a>
                        </li>
                        <li>
                            <a Link href="https://app.orbpad.finance/lock" target="_blank">OrbPad Lock</a>
                        </li>
                    </ul>

                    <div className="copyright-text">
                        Copyright © 2024. All Rights Reserved by {" "}
                        <a href="# " target="_blank">OrbPad</a>
                    </div>
                </div>
            </div>
        </FooterBottomStyleWrapper>
    )
}
